import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetPageDefaultStyle0 = gravityIconIndividualCss;

const GravityIconAssetPageDefault = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '5c1813625e015a99d116855c058bf088f8d15bfd', color: this.color, size: this.size }, h("svg", { key: '31b361f89515fad080c93bac084ac31981d7382a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '9c591112a2d3bf11dd06dd6292369aad41472ec6', d: "M6 7.5a.25.25 0 0 1 .25-.25h9.5a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-9.5A.25.25 0 0 1 6 8.5v-1Zm0 3a.25.25 0 0 1 .25-.25h9.5a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-9.5A.25.25 0 0 1 6 11.5v-1Zm.25 2.75a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25h-9.5Z", fill: "currentColor" }), h("path", { key: '28bea269283893b602caac20b8c84765d62feb53', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4h17c.276 0 .5.21.5.471V17.53c0 .26-.224.471-.5.471h-17c-.276 0-.5-.21-.5-.471V4.47c0-.26.224-.471.5-.471Zm16 12.5v-11h-15v11h15Z", fill: "currentColor" }))));
    }
};
GravityIconAssetPageDefault.style = GravityIconAssetPageDefaultStyle0;

export { GravityIconAssetPageDefault as gravity_icon_asset_page_default };

//# sourceMappingURL=gravity-icon-asset-page-default.entry.js.map